import { createContext, useCallback, useContext, useRef, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button,
} from '@mui/material';

const ConfirmContext = createContext(async () => true);

/**
 * «Вы действительно хотите…?» — бир жалпы ырастоо терезеси.
 *
 *   const confirm = useConfirm();
 *   if (!(await confirm({ title: 'Удалить термин?', text: '…', okLabel: 'Удалить', danger: true }))) return;
 *
 * Өзгөртүү же өчүрүү кылган аракеттерде гана колдонулат — текстти оңдоо,
 * главаны тандоо сыяктуу ар бир баскычта суралбайт (колдонуучу окубай эле
 * «Да» басып калат да, суроонун мааниси жоголот).
 */
export function ConfirmProvider({ children }) {
  const [state, setState] = useState(null);
  const resolver = useRef(null);

  const confirm = useCallback((opts = {}) => new Promise((resolve) => {
    resolver.current = resolve;
    setState(opts);
  }), []);

  const close = (result) => {
    resolver.current?.(result);
    resolver.current = null;
    setState(null);
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <Dialog open={Boolean(state)} onClose={() => close(false)} maxWidth="xs" fullWidth>
        <DialogTitle>{state?.title ?? 'Вы действительно хотите изменить это?'}</DialogTitle>
        {state?.text && (
          <DialogContent>
            <DialogContentText>{state.text}</DialogContentText>
          </DialogContent>
        )}
        <DialogActions>
          <Button color="inherit" onClick={() => close(false)}>{state?.cancelLabel ?? 'Отмена'}</Button>
          <Button variant="contained" color={state?.danger ? 'error' : 'primary'} onClick={() => close(true)} autoFocus>
            {state?.okLabel ?? 'Да, изменить'}
          </Button>
        </DialogActions>
      </Dialog>
    </ConfirmContext.Provider>
  );
}

export const useConfirm = () => useContext(ConfirmContext);
